// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json_decode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as WalletStateMapper from "../entity-mapper/WalletStateMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as ResponseConverterNew$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseConverterNew.bs.js";

function execute(data) {
  return WalletStateMapper.WalletReportStateMapper.execute(data);
}

var WalletTransactionsConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var WalletTransactionsResponseConverter = partial_arg(WalletTransactionsConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = WalletStateMapper.AdminTransactionReasonsMapper.execute;

var WalletTransactionReasonsConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var WalletTransactionReasonsConverter = partial_arg$1(WalletTransactionReasonsConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function parseSuccessResponse(data) {
  var statusCode = Json_decode.field("status", Json_decode.$$int, data);
  if (statusCode !== 200) {
    return ;
  } else {
    return {
            title: "Success",
            message: "Success"
          };
  }
}

function execute$2(response) {
  if (typeof response === "number") {
    return ;
  }
  switch (response.TAG | 0) {
    case /* Success */0 :
        return parseSuccessResponse(response._0);
    case /* SuccessWithNoContent */1 :
        return {
                title: "Success",
                message: "Success"
              };
    default:
      return ;
  }
}

var AdminTransactionSuccessConverter = {
  parseSuccessResponse: parseSuccessResponse,
  execute: execute$2
};

function parseError(json) {
  var statusCode = Json_decode.field("status", Json_decode.$$int, json);
  if (statusCode !== 409) {
    if (statusCode !== 422) {
      return ;
    } else {
      return /* DefaultError */{
              _0: {
                title: /* InternalServerError */3,
                message: Json_decode.field("reason", Json_decode.string, json)
              }
            };
    }
  } else {
    return /* DefaultError */{
            _0: {
              title: /* DataConflict */4,
              message: Json_decode.field("reason", Json_decode.string, json)
            }
          };
  }
}

function execute$3(response) {
  if (typeof response === "number" || response.TAG !== /* Success */0) {
    return ResponseHandler$Catalyst.DefaultErrorConverter.execute(response);
  } else {
    return parseError(response._0);
  }
}

var AdminTransactionErrorConverter = {
  parseError: parseError,
  execute: execute$3
};

var partial_arg$2 = {
  execute: execute$2
};

var partial_arg$3 = ResponseConverterNew$Catalyst.Converter;

var AdminTransactionResponseConverter = (function (param) {
      return partial_arg$3(partial_arg$2, param);
    })({
      execute: execute$3
    });

export {
  WalletTransactionsConfig ,
  WalletTransactionsResponseConverter ,
  WalletTransactionReasonsConfig ,
  WalletTransactionReasonsConverter ,
  AdminTransactionSuccessConverter ,
  AdminTransactionErrorConverter ,
  AdminTransactionResponseConverter ,
  
}
/* WalletTransactionsResponseConverter Not a pure module */
